export default {
  default: {
    blankStateText: 'You can choose the order in which images are sorted. Click on the images to set the order you’d like them to appear.',
    blankStateTitle: 'Click on images to sort',
    saveImageSort: 'Save Image Sort',
  },
}
